export function durationToHoursIncludingDays(duration: moment.Duration): number {
    const daysInHours: number = duration.days() * 24;
    return duration.hours() + daysInHours;
}
